import Rose from './modifiers/rose';
import Lissajous from './modifiers/lissajous';
import PixelObject from './PixelObject'

export default class Copy extends PixelObject {
    constructor(options) {
        super(options);

        const defaults = {
            type: 'COPY',
            name: 'Copy',
            width: 512,
            height: 512,
            count: 5000,
            modifiers: [new Lissajous({ parent: this })],
        }

        let opts = { ...defaults, ...options }

        this.type = opts.type
        this.name = opts.name
        this.count = opts.count
        this.width = opts.width
        this.height = opts.height

        this.modifiers = opts.modifiers

        this.createBuffer()
    }

    set(key, newValue) {

        switch (key) {
            case 'count': {
                this.count = newValue
                this.dispatch('objectStateChanged', this.propertyChangedMessage(key))
                return;
            }
        }

        PixelObject.prototype.set.call(this, key, newValue)
    }

    get(key) {
        switch (key) {
            case 'width': {
                return this.cellWidth * this.col
            }
            case 'height': {
                return this.cellHeight * this.rows
            }
        }
        return PixelObject.prototype.get.call(this, key)
    }

    renderBuffer() {
        // if (!this.children.length) return

        console.log("Copy regenerating")

        const self = this

        this.buffer.clear()

        console.time("iterationTime")
        for (let count = 0; count < this.count; count++) {
            this.children.forEach(e => {
                let element
                if (count == 0) {
                    element = e.getCachedCopy({ forcedUpdate: true })
                } else {
                    element = e.getCachedCopy()
                }
                element.ctx = this.buffer
                this.modifiers.forEach(modifier => {
                    modifier.apply({ element, count, width: self.width, height: self.height, placeOnPath: element.placeOnPath })
                })
                element.draw()
            })
        }
        console.timeEnd("iterationTime");

        this.stop = false
    }

    draw() {
        if (this.visible == '0' || this.deleted) return

        this.ctx.push()

        if (!this.stop) {
            console.log("Generating buffer")
            this.stop = true
            this.image = this.buffer.createImage(this.ctx.width, this.ctx.height)
            this.image.copy(this.buffer, 0, 0, this.ctx.width, this.ctx.height, 0, 0, this.ctx.width, this.ctx.height)
        }

        if (this.image) {
            this.ctx.translate(-this.width / 2, -this.height / 2)
            this.position()
            if (this.opacity !== 100) {
                this.ctx.tint(255, 255 / 100 * this.opacity)
            }
            this.ctx.image(this.image, 0, 0);
        }

        this.ctx.pop()
    }
}